var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23597_127356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4 8.08871C17.4 9.53648 16.7659 11.9186 15.7105 13.9454C15.1859 14.9527 14.5757 15.8357 13.9217 16.4586C13.2644 17.0846 12.616 17.3999 12 17.3999C11.384 17.3999 10.7356 17.0846 10.0783 16.4586C9.42434 15.8357 8.81411 14.9527 8.28953 13.9454C7.2341 11.9186 6.6 9.53648 6.6 8.08871C6.6 5.30795 8.98715 2.9999 12 2.9999C15.0128 2.9999 17.4 5.30795 17.4 8.08871Z",
    stroke: "#009EF7",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.0004,
    cy: 8.40005,
    r: 3,
    stroke: "#009EF7",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 14.4L2.99702 16.3038C1.95382 16.6714 1.92117 18.1348 2.94694 18.5485L11.5394 22.0142C11.8343 22.1332 12.1644 22.1302 12.4572 22.0059L20.6513 18.5269C21.6467 18.1043 21.6191 16.6841 20.608 16.3004L15.6 14.4",
    stroke: "#009EF7",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23597_127356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f76842ad238aff87358efb46883c7155.svg";
export { ForwardRef as ReactComponent };